import classNames from 'classnames';
import { useAppContext, useAppDispatcher } from '@Comments/context/AppContext';

import './Header.scss';

export const Header = () => {
  const { layout, commentsCount } = useAppContext();
  const dispatch = useAppDispatcher();

  const onClickHeader = () => {
    dispatch({ type: 'set-expand', data: !layout.isExpanded });
  };

  return (
    <div className="srf-comments-header-wrapper">
      <div className="srf-comments-header" onClick={onClickHeader}>
        <h2 className="srf-comments-header-title">
          {commentsCount} {commentsCount === 1 ? 'Kommentar' : 'Kommentare'}
        </h2>
        <div
          className="srf-comments-header-expand-container"
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              onClickHeader();
            }
          }}>
          <div>{layout.isExpanded ? 'Ausblenden' : 'Einblenden'}</div>
          <div
            className={classNames('srf-comments-header-expand-switch', {
              'srf-comments-header-expand-switch--closed': !layout.isExpanded,
            })}></div>
        </div>
      </div>
    </div>
  );
};
